<template>
    <v-row :style="{ paddingLeft: filtersVisible ? '0px' : '10px' }">
        <v-col>
            <v-card>
                <v-card-title class="d-flex justify-center">50 000 tk</v-card-title>
                <v-card-text class="d-flex justify-center">Tellimusi</v-card-text>
            </v-card>
        </v-col>

        <v-col>
            <v-card>
                <v-card-title class="d-flex justify-center">1 123 123 123 €</v-card-title>
                <v-card-text class="d-flex justify-center">Käive</v-card-text>
            </v-card>
        </v-col>

        <v-col>
            <v-card>
                <v-card-title class="d-flex justify-center">8 225 879 €</v-card-title>
                <v-card-text class="d-flex justify-center">Käive KM'ta</v-card-text>
            </v-card>
        </v-col>
        <v-col>
            <v-card>
                <v-card-title class="d-flex justify-center">1 329 171 000 kg</v-card-title>
                <v-card-text class="d-flex justify-center">Netokaal</v-card-text>
            </v-card>
        </v-col>
        <v-col>
            <v-card>
                <v-card-title class="d-flex justify-center">12 649 350</v-card-title>
                <v-card-text class="d-flex justify-center">Arveldatud kogused</v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
import {mapMutations, mapState, mapActions} from "vuex";

export default {
    name: 'analysis-stat-row',
    data() {
        return {
        }
    },
    methods: {
        ...mapActions("AnalysisStore", []),
        ...mapMutations("AnalysisStore", []),
    },
    computed: {
        ...mapState("AnalysisStore", ['filtersVisible']),
    }
};
</script>

<style scoped>
</style>
